$(document).ready(function(){
  // mega_menu sub_menu selection 
  $("li.main_menu_cu").on("click", function(){
      // Reset font-family for all siblings within the same mega-menu
      const $megaMenu = $(this).closest(".mega-menu");

      // Show only the relevant submenu within the same mega-menu
      let $child_mm = $(this).find("ul.sub_menu_cu");
      if($child_mm.length > 0){
          $megaMenu.find("ul.sub_menu_cu").hide();
          $megaMenu.find("li.active").removeClass('active');
          $child_mm.css('display', 'flex');
          $(this).addClass('active');
      }
  });
});





// let maxHeight = 0;
// document.querySelectorAll('.reviews-card').forEach(el => {
//   if (el.offsetHeight > maxHeight) {
//     maxHeight = el.offsetHeight;
//   }
// });

// document.querySelectorAll('.reviews-card').forEach(el => {
//   el.style.height = maxHeight + 'px';
// });

function handleSticky() {
  const stickyEl = document.querySelector('.sub_collection_section');
  const header = document.querySelector('.shopify-section--header');
  const announcementBar = document.querySelector('.announcement-bar');
  const wrapper = document.querySelector('.subcollections_wrapper');

  if (!stickyEl || !header) return;

  let headerHeight = header.offsetHeight;

  // add announcement bar height
  if (announcementBar) {
    headerHeight += announcementBar.offsetHeight;
  }

  // condition 1: above 767px screen → minus 2px
  if (window.innerWidth > 767) {
    headerHeight = headerHeight - 2;
  }

  // apply sticky top
  stickyEl.style.top = headerHeight + 'px';

  const rect = stickyEl.getBoundingClientRect();

  if (rect.top <= headerHeight) {
    stickyEl.classList.add('is-sticky');

    // condition 2: above 767px & sticky
    if (window.innerWidth > 767 && wrapper) {
      wrapper.style.paddingBottom = '0px';
    }

  } else {
    stickyEl.classList.remove('is-sticky');

    // reset padding if not sticky
    if (wrapper) {
      wrapper.style.paddingBottom = '';
    }
  }
}

window.addEventListener('load', handleSticky);
window.addEventListener('scroll', handleSticky);
window.addEventListener('resize', handleSticky);


document.querySelector('.custom_sticky_add span')?.addEventListener('click', function () {
  const stickyButton = this;
  const buyButton = document.querySelector('buy-buttons .button');

  if (!buyButton) return;

  console.log('sticky click');

  // Add loader
  stickyButton.classList.add('loading');
  stickyButton.style.pointerEvents = 'none';
  const activeEl = document.activeElement;

  if (activeEl && activeEl !== document.body) activeEl.blur();
  // Trigger actual ATC button click
  buyButton.click();

  // Watch aria-busy changes
  const observer = new MutationObserver(() => {
    const isBusy = buyButton.getAttribute('aria-busy') === 'true';

    if (!isBusy) {
      stickyButton.classList.remove('loading');
      stickyButton.style.pointerEvents = 'auto';
      observer.disconnect();
    }
  });

  observer.observe(buyButton, {
    attributes: true,
    attributeFilter: ['aria-busy']
  });

  // Fallback if aria-busy never becomes true
  setTimeout(() => {
    const isBusy = buyButton.getAttribute('aria-busy') === 'true';

    if (!isBusy) {
      stickyButton.classList.remove('loading');
      stickyButton.style.pointerEvents = 'auto';
      observer.disconnect();
    }
  }, 300);
});


document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.product-info__quantity-selector').forEach(function(wrapper){

    const input = wrapper.querySelector('.quantity-selector__input');
    const minusBtn = wrapper.querySelector('.quantity-selector__button:first-child');
    const plusBtn = wrapper.querySelector('.quantity-selector__button:last-child');

    function updateButtons() {
      const value = parseInt(input.value) || 1;
      const min = parseInt(input.min) || 1;
      const max = input.max ? parseInt(input.max) : null;

      // Disable minus button
      if (value <= min) {
        minusBtn.classList.add('disabled');
      } else {
        minusBtn.classList.remove('disabled');
      }

      // Disable plus button
      if (max !== null && value >= max) {
        plusBtn.classList.add('disabled');
      } else {
        plusBtn.classList.remove('disabled');
      }
    }

    // Initial load
    updateButtons();

    // Plus / Minus click
    wrapper.querySelectorAll('.quantity-selector__button').forEach(function(btn){
      btn.addEventListener('click', function(){
        setTimeout(updateButtons, 50);
      });
    });

    // Manual input change
    input.addEventListener('input', updateButtons);

  });

});



new Swiper(".mob_menu_top_slider", {
  grabCursor: true,
  slidesPerView: 3.2,
  spaceBetween: 8,
  speed: 600,
  slidesOffsetAfter: 0,
  freeMode: true,
  mousewheel: {
    forceToAxis: true,   // only react to horizontal 2-finger / wheel scroll
    releaseOnEdges: true // hand scroll back to the page at the ends
  },
  breakpoints: {
    375: {
      slidesPerView: 3.2,
      spaceBetween: 8
    },
    425: {
      slidesPerView: 4.5,
      spaceBetween: 8
    },
    768: {
      slidesPerView: 4.2,
      spaceBetween: 8
    },
    1024: {
      slidesPerView: 4.5,
      spaceBetween: 8
    }
  }
});
new Swiper(".combo_slider_product", {
  grabCursor: true,
  slidesPerView: 2.2,
  spaceBetween: 8,
  speed: 600,
  slidesOffsetAfter: 0,   // ← removes trailing offset
  freeMode: true,          // ← allows sliding to stop anywhere naturally  
      breakpoints: {
      600: {
        slidesPerView: 3,
        spaceBetween: 8
      },
      1024: {
        slidesPerView: 2.5,
        spaceBetween: 8
      },
    }
});

function initSearchSwiper() {
  const slider = document.querySelector(".search_slider_product");

  if (!slider || slider.swiper) return;

  new Swiper(slider, {
    grabCursor: true,
    slidesPerView: 2.2,
    spaceBetween: 8,
    speed: 600,
    slidesOffsetAfter: 0,
    freeMode: true,
    breakpoints: {
      375: {
        slidesPerView: 1.5,
        spaceBetween: 8
      },
      425: {
        slidesPerView:  2.2,
        spaceBetween: 8
      }
    }
  });
}

function initSearchSwiper2() {
  const slider = document.querySelector(".search_slider_col");

  if (!slider || slider.swiper) return;

  new Swiper(slider, {
    grabCursor: true,
    slidesPerView: 6.2,
    spaceBetween: 8,
    speed: 600,
    slidesOffsetAfter: 0,
    freeMode: true,
    breakpoints: {
      375: {
        slidesPerView: 3.5,
        spaceBetween: 8
      },
      767: {
        slidesPerView:  5.2,
        spaceBetween: 8
      }
    }
  });
}
// Watch search drawer for dynamic content updates
const searchDrawer = document.querySelector("#search-drawer");

if (searchDrawer) {
  const observer = new MutationObserver(() => {
    initSearchSwiper();
    initSearchSwiper2();
  });

  observer.observe(searchDrawer, {
    childList: true,
    subtree: true
  });
}



(function () {
  const STORAGE_KEY = 'search_recent';
  const MAX_ITEMS = 6;

  function getRecent() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch { return []; }
  }

  function saveRecent(terms) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(terms));
  }

  function addSearch(term) {
    if (!term || term.trim().length < 2) return;
    let terms = getRecent();
    terms = terms.filter(t => t.toLowerCase() !== term.toLowerCase());
    terms.unshift(term.trim());
    terms = terms.slice(0, MAX_ITEMS);
    saveRecent(terms);
  }

  function renderRecent() {
    const wrapper = document.getElementById('recent-searches-wrapper');
    const list = document.getElementById('recent-searches-list');
    if (!wrapper || !list) return;

    const terms = getRecent();
    if (terms.length === 0) {
      wrapper.style.display = 'none';
      return;
    }

    wrapper.style.display = '';
    list.innerHTML = terms.map(term => `
      <li>
        <a href="/search?q=${encodeURIComponent(term)}">${term}</a>
      </li>
    `).join('');
  }

  function initListeners() {
    const searchInput = document.querySelector('search-drawer input[name="q"]');
    if (!searchInput) return;

    let saveTimeout;

    // Save while typing (debounced) — triggers when predictive search fires
    searchInput.addEventListener('input', () => {
      const term = searchInput.value.trim();
      clearTimeout(saveTimeout);

      if (term.length >= 2) {
        saveTimeout = setTimeout(() => {
          addSearch(term);
          renderRecent();
        }, 800);
      }
    });

    // Save on form submit (enter key)
    const form = searchInput.closest('form');
    if (form) {
      form.addEventListener('submit', () => {
        clearTimeout(saveTimeout);
        const term = searchInput.value.trim();
        if (term) {
          addSearch(term);
          renderRecent();
        }
      });
    }

    // Save when clicking a predictive suggestion link
    document.addEventListener('click', (e) => {
      const link = e.target.closest('.predictive-search a');
      if (link) {
        const text = link.textContent.trim();
        if (text) {
          addSearch(text);
          renderRecent();
        }
      }
    });
  }

  // Re-render recent searches when drawer opens
  const drawer = document.getElementById('search-drawer');
  if (drawer) {
    const observer = new MutationObserver(() => {
      renderRecent();
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['open', 'class'] });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initListeners();
      renderRecent();
    });
  } else {
    initListeners();
    renderRecent();
  }

})();



window.flashTimer = function() {
  const timerSections = document.querySelectorAll(
    ".cart-flash-timer, .section-flash-timer"
  );

  if (!timerSections.length) return;

  timerSections.forEach((timerSection) => {
    const endTime = timerSection.dataset.endTime;
    const targetDate = new Date(endTime).getTime();

    if (isNaN(targetDate)) {
      timerSection.style.display = "none";
      return;
    }

    const daysElement = timerSection.querySelector(".timer-days");
    const hoursElement = timerSection.querySelector(".timer-hours");
    const minutesElement = timerSection.querySelector(".timer-minutes");
    const secondsElement = timerSection.querySelector(".timer-seconds");


    let timerInterval;

    function updateTimer() {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance <= 0) {
        timerSection.style.display = "none";
        clearInterval(timerInterval);
        return;
      }

      const days = Math.floor(
        distance / (1000 * 60 * 60 * 24)
      );

      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) /
        (1000 * 60 * 60)
      );

      const minutes = Math.floor(
        (distance % (1000 * 60 * 60)) /
        (1000 * 60)
      );

      const seconds = Math.floor(
        (distance % (1000 * 60)) /
        1000
      );

      daysElement.textContent = String(days).padStart(2, "0");
      hoursElement.textContent = String(hours).padStart(2, "0");
      minutesElement.textContent = String(minutes).padStart(2, "0");
      secondsElement.textContent = String(seconds).padStart(2, "0");
    }

    updateTimer();

    timerInterval = setInterval(updateTimer, 1000);
  });
};






let desktopSwiper = null;

function initDesktopSwiper() {
  const slider = document.querySelector('.desktop-only-swiper');

  if (!slider) return;

  if (window.innerWidth >= 768) {
    if (!desktopSwiper) {
      desktopSwiper = new Swiper(slider, {
        slidesPerView: 4,
        spaceBetween: 20,
        simulateTouch:false,
        loop: false,
        autoplay: false,
         touchStartPreventDefault: false,
         freeMode: false,
        navigation: {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev')
        },

        breakpoints: {
          768: {
            slidesPerView: 3
          },
          1024: {
            slidesPerView: 4
          },
          1440: {
            slidesPerView: 4
          }
        }
      });
    }
  } else if (desktopSwiper) {
    desktopSwiper.destroy(true, true);
    desktopSwiper = null;
  }
}


initDesktopSwiper();
window.addEventListener('resize', initDesktopSwiper);


document.addEventListener('DOMContentLoaded', function () {
  window.flashTimer();
});